(function () {
  const DESKTOP_MIN_WIDTH = 990;

  // Delegated click survives theme editor re-renders/morphs without re-init; the window
  // flag keeps the listener single when the editor re-executes this script.
  if (window.__themeFooterAccordionEvents) return;
  window.__themeFooterAccordionEvents = true;

  // The panel animates itself in CSS — the script only flips the state attribute
  document.addEventListener("click", (event) => {
    const heading = event.target.closest(".footer__nav-heading");
    if (!heading || window.innerWidth >= DESKTOP_MIN_WIDTH) return;

    const row = heading.closest(".js-accordion-mobile");
    if (!row) return;

    if (row.hasAttribute("open")) {
      row.removeAttribute("open");
    } else {
      row.setAttribute("open", "true");
    }
  });
})();
